function island(name, overrides = {}) {
    return {
        name,
        payloadId: overrides.payloadId ?? `${name}-init`,
        rootId: overrides.rootId ?? `${name}-root`,
    };
}
export const Islands = {
    /**
     * Bootstrap config. `payloadId` is overridden: this island predates the naming
     * convention and its id is read by an already-deployed bundle.
     */
    config: island("config", { payloadId: "__config" }),
    /** /dashboard Overview charts. Renders into per-chart containers, not `rootId`. */
    /** Google Ads enhanced-conversion event. Payload only — no component. */
    conversionTag: island("conversion-tag"),
    /** Experimental vector-search page (/labs/search). */
    labsSearch: island("labs-search"),
    /** Front-page Advanced search box (axes/negative/classic) under the search bar. */
    frontAdvanced: island("front-advanced"),
    /**
     * Content-loader seed state. Payload only — the loader renders into the
     * container named by `payload.targetId`, not into this island's `rootId`.
     */
    loader: island("loader"),
};
//# sourceMappingURL=islands.js.map